import { API_URL, is_dev_env } from "../../Util/constant";

// Login
export async function login(params) {
    try {
        var reqHeader = new Headers();
        reqHeader.append("Content-Type", "application/json");
        const response = await fetch(`${API_URL}/auth/login`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: reqHeader,
            // mode:'no-cors',
            redirect: "follow",
        });
        const rresponse = await response.json();
        if (!rresponse.error) {
            return rresponse;
        } else if (rresponse.error) {
            return rresponse.error.data;
        } else {
            throw new Error("Unknown error. Please try again.");
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}

export async function makeGetApiRequest(path) {
    try {
        const response = await fetch(`${API_URL}${path}`, {
            headers: { Authorization: localStorage.getItem("user_access_token") },
        });
        if (response.status === 401 && !is_dev_env) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        let ret_data = await response.json();
        return ret_data;
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}

export async function makeApiRequest(path, params) {
    try {
        var reqHeader = new Headers();
        reqHeader.append(
            "Authorization",
            localStorage.getItem("user_access_token")
        );
        reqHeader.append("Content-Type", "application/json");
        const response = await fetch(`${API_URL}${path}`, {
            method: "POST",
            body: JSON.stringify(params),
            headers: reqHeader,
            // mode:'no-cors',
            redirect: "follow",
        });
        if (response.status === 401 && !is_dev_env) {
            localStorage.removeItem("user_access_token");
            window.location.href = "/login";

        }
        const rresponse = await response.json();
        if (!rresponse.error) {
            return { result: rresponse };
        } else {
            return { error: rresponse.error.data };
        }
    } catch (error) {
        console.error(error);
        return {
            error: {
                title: "Api request error",
                message: "Api request error",
                error: error,
            },
        };
    }
}

// Forgot Password
export async function forgotPassword(set_values) {
    const response = await makeApiRequest(
        "/auth/forgotpassword",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// Reset Password
export async function resetPassword(set_values) {
    const response = await makeApiRequest(
        "/auth/resetpassword",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// Get Sponsor name
export async function getSponsorUserName(set_values) {
    const response = await makeApiRequest(
        "/auth/getsponserusername",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// Get Countries
export async function getCountries() {
    const response = await makeGetApiRequest(
        "/auth/getcountries"
    );
    if (response.data) {
        return response;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}

// Register User
export async function register(set_values) {
    const response = await makeApiRequest(
        "/auth/register",
        set_values
    );

    if (response.result) {
        return response.result;
    } else if (response.error) {
        throw new Error(response.error.message);
    } else {
        throw new Error("Unknown error. Please try again.");
    }
}